import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-16547e30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "oaiBestTooltipArrow absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-oaiGray-500"
}
const _hoisted_2 = {
  key: 1,
  class: "oaiBestTooltipArrow absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-8 border-b-oaiGray-500"
}
const _hoisted_3 = {
  key: 2,
  class: "oaiBestTooltipArrow absolute top-1/2 right-0 translate-x-1/2 -translate-y-1/2 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-oaiGray-500"
}
const _hoisted_4 = {
  key: 3,
  class: "oaiBestTooltipArrow absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 border-t-8 border-t-transparent border-b-8 border-b-transparent border-r-8 border-r-oaiGray-500"
}

import { computed, ref, watch } from "vue";

const verticalSpace = 4;
const horizontalSpace = 4;

type TooltipPosition = "top" | "bottom" | "left" | "right";


export default /*#__PURE__*/_defineComponent({
  __name: 'OaiTooltip',
  props: {
    simple: { type: Boolean, default: true },
    position: { default: "bottom" },
    cls: {},
    style: {}
  },
  emits: ["click", "show", "hide"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isTooltipVisible = ref(false);
const containerElementRef = ref<HTMLDivElement | null>(null);
const tooltipElementRef = ref<HTMLDivElement | null>(null);
const positionX = ref<number | null>(null);
const positionY = ref<number | null>(null);

const calculateCoordinates = (
  position: TooltipPosition,
): [number | null, number | null, number | null, number | null] => {
  if (!containerElementRef.value || !tooltipElementRef.value) {
    return [null, null, null, null];
  }

  const containerRect = containerElementRef.value.getBoundingClientRect();
  const tooltipRect = tooltipElementRef.value.getBoundingClientRect();

  const positions: Record<TooltipPosition, [number, number]> = {
    top: [
      containerRect.left + (containerRect.width - tooltipRect.width) / 2,
      containerRect.top - tooltipRect.height - verticalSpace,
    ],
    bottom: [
      containerRect.left + (containerRect.width - tooltipRect.width) / 2,
      containerRect.bottom + verticalSpace,
    ],
    left: [
      containerRect.left - tooltipRect.width - horizontalSpace,
      containerRect.top + (containerRect.height - tooltipRect.height) / 2,
    ],
    right: [
      containerRect.right + horizontalSpace,
      containerRect.top + (containerRect.height - tooltipRect.height) / 2,
    ],
  };

  const [x, y] = positions[position];
  return [x, y, x + tooltipRect.width, y + tooltipRect.height];
};

const doesItFit = (position: TooltipPosition) => {
  const [top, left, right, bottom] = calculateCoordinates(position);
  if (top === null || left === null || right === null || bottom === null) {
    return false;
  }
  return top >= 0 && left >= 0 && right <= window.innerWidth && bottom <= window.innerHeight;
};

const finalPosition = computed(() => {
  const fallbackPositions: Record<TooltipPosition, TooltipPosition[]> = {
    top: ["bottom", "left", "right"],
    bottom: ["top", "left", "right"],
    left: ["right", "top", "bottom"],
    right: ["left", "top", "bottom"],
  };
  return (
    [props.position, ...fallbackPositions[props.position]].find((position) =>
      doesItFit(position),
    ) || props.position
  );
});

const updateTooltipPosition = () => {
  const [x, y] = calculateCoordinates(finalPosition.value);
  positionX.value = x;
  positionY.value = y;
};

const showTooltip = (visible: boolean) => {
  positionX.value = null;
  positionY.value = null;
  isTooltipVisible.value = visible;
  emit(visible ? "show" : "hide");
};

watch(tooltipElementRef, () => {
  updateTooltipPosition();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "containerElementRef",
      ref: containerElementRef,
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showTooltip(true))),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showTooltip(false))),
      class: _normalizeClass(["min-w-0", _ctx.cls]),
      style: _normalizeStyle(_ctx.style),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('click')))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 38),
    (isTooltipVisible.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#tooltip"
        }, [
          _createElementVNode("div", {
            ref_key: "tooltipElementRef",
            ref: tooltipElementRef,
            class: _normalizeClass(["fixed oaiBestTooltipHoverElement", _ctx.simple ? 'bg-oaiGray-500 opacity-0.8 text-white rounded p-3 text-sm' : '']),
            style: _normalizeStyle({
        top: `${positionY.value === null ? -10000 : positionY.value}px`,
        left: `${positionX.value === null ? -10000 : positionX.value}px`,
        zIndex: 999999,
      })
          }, [
            (_ctx.simple && finalPosition.value === 'top')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1))
              : _createCommentVNode("", true),
            (_ctx.simple && finalPosition.value === 'bottom')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2))
              : _createCommentVNode("", true),
            (_ctx.simple && finalPosition.value === 'left')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3))
              : _createCommentVNode("", true),
            (_ctx.simple && finalPosition.value === 'right')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "tooltip")
          ], 6)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})